import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject, input, signal } from '@angular/core';

import { ImageModule } from 'Angular/features/directives/image/image.module';

@Component({
    selector: 'ycn-agent-loader',
    imports: [ImageModule],
    templateUrl: './agent-loader.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentLoaderComponent {
    readonly currentLoadingText = input<string>('');

    // replace the ... that comes from our messages and animate our own
    protected readonly loadingLabel = computed(() => this.currentLoadingText().replace(/\.{3}$/, ''));

    protected readonly elapsedSeconds = signal(0);

    private readonly _startedAt = Date.now();

    constructor() {
        const intervalId = window.setInterval(() => {
            this.elapsedSeconds.set(Math.round((Date.now() - this._startedAt) / 1000));
        }, 1000);
        inject(DestroyRef).onDestroy(() => window.clearInterval(intervalId));
    }
}
